<!-- 直播保量数据导入记录 -->
<template>
  <div v-permission="'live_guarantee__import_record'" style="display: inline;">
    <el-link type="primary" @click="handleShow">查看导入记录</el-link>
    <el-drawer title="导入记录" :visible.sync="show" :close-on-press-escape='false' :wrapper-closable='false'
               custom-class="live-guarantee-import-drawer default-table">
      <el-table class="import-table" :data="table" style="width: 100%;" height="calc(100% - 68px)">
        <el-table-column type="index" label="状态" width="100" align="center">
          <template v-slot="{row:{rows_count,success_count,undo_is}}">
            <el-tag v-if="undo_is==='Y'" type="info" effect="dark">已撤销</el-tag>
            <template v-else>
              <el-tag v-if="rows_count===success_count" type="success">全部成功</el-tag>
              <el-tag v-else-if="rows_count>success_count&&success_count>0" type="danger">
                部分失败
              </el-tag>
              <el-tag v-else-if="success_count===0" type="info">未导入</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="文件名" show-overflow-tooltip/>
        <el-table-column label="总条数">
          <template v-slot="{row:{rows_count}}">
            {{ rows_count|numberFormat }}
          </template>
        </el-table-column>
        <el-table-column label="成功导入">
          <template v-slot="{row:{success_count}}">
            {{ success_count|numberFormat }}
          </template>
        </el-table-column>
        <el-table-column label="导入耗时">
          <template v-slot="{row:{use_time}}">
            {{ (use_time / 1000)|numberFormat(2) }}s
          </template>
        </el-table-column>
        <el-table-column prop="create_or" label="导入用户" show-overflow-tooltip/>
        <el-table-column prop="created_at" label="导入时间" show-overflow-tooltip>
          <template v-slot="{row:{created_at}}">
            {{ created_at|parseTime('{m}/{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column prop="undo_or" label="撤回用户" show-overflow-tooltip/>
        <el-table-column prop="undo_at" label="撤回时间" show-overflow-tooltip>
          <template v-slot="{row:{undo_at}}">
            {{ undo_at|parseTime('{m}/{d} {h}:{i}') }}
          </template>
        </el-table-column>
        <el-table-column prop="undo_type" label="撤回类型">
          <template v-slot="{row:{undo_type}}">
            <span v-if="undo_type==='ONLY_WAIT'">
              仅删除 “未认领”
            </span>
            <span v-if="undo_type==='NOT_CONFIRM'">
              除了 “已确认”，此外全部删除
            </span>
            <span v-if="undo_type==='ALL'">
              全部删除
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-link v-permission="'live_guarantee__import_undo'"
                     v-if="row.undo_is==='N'" type="danger"
                     @click="handleUndo(row)">撤回
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
            background
            :current-page="search.page"
            :page-size="search.page_size"
            layout="total, prev, pager, next"
            :total="search.total"
            style="float: right;"
            @current-change="handleCurrentChange"
        />
      </div>

      <el-dialog :title="`确认撤回于${dialog.time}的导入记录吗？`" :visible.sync="dialog.show" width="500px" center
                 :close-on-press-escape="false" :close-on-click-modal="false"
                 :modal-append-to-body="true" :append-to-body="true"
      >
        <h3 style="text-align: center">
          撤回导入行为，将<b style="color: darkred;">删除</b>对应的直播保量数据。
        </h3>
        <div style="width: 80%;margin: 20px auto;">
          <el-radio v-model="dialog.undo_type" label="ONLY_WAIT">仅删除 “未认领”</el-radio>
          <br/>
          <el-radio v-model="dialog.undo_type" label="NOT_CONFIRM">除了 “已确认”，此外全部删除</el-radio>
          <br/>
          <el-radio v-model="dialog.undo_type" label="ALL">全部删除（若存在“已确认”数据，汇总数据将<b
              style="color: darkred;">重新计算</b>）
          </el-radio>
          <br/>
        </div>
        <div style="text-align: center;margin-top: 50px;">
          <el-button @click="dialog.show = false">取 消</el-button>
          <button-submit :disabled="!dialog.undo_type" button-txt="确 认" type="primary"
                         @click.native.prevent="handleUndoSure"/>
        </div>
      </el-dialog>
    </el-drawer>
  </div>
</template>
<script>
import {importRecordsList} from "../../../../api/importRecords";
import {liveGuaranteeUndoImport} from "../../../../api/liveGuarantee";

export default {
  name: 'importRecords',
  props: {
    module: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      dialog: {
        import_record_id: null,
        show: false,
        undo_type: null,
      },
      table: [],
      search: {
        table: this.module,
        page: 1,
        total: 0,
        page_size: 20,
      }
    }
  },
  methods: {
    handleShow: function () {
      this.show = true
      this.handleSearch()
    },
    handleUndo: function (row) {
      this.dialog = {
        import_record_id: row.id,
        time: row.created_at,
        show: true,
        undo_type: null,
      }
    },
    handleUndoSure: async function () {
      const {success} = await liveGuaranteeUndoImport(this.dialog)
      if (success) {
        this.$message.success('操作成功！')
        this.$emit('refresh')
        this.handleSearch()
        this.dialog.show = false
      }
    },
    handleSearch: function () {
      this.search.page = 1
      this.getData()
    },
    getData: async function () {
      const {model: {data, total}} = await importRecordsList(this.search)
      this.loading = false
      this.search.total = total || 0
      this.table = data || []
    },
    handleCurrentChange: function (page) {
      this.search.page = page
      this.getData()
    }
  }
}
</script>
<style lang="scss">
.live-guarantee-import-drawer {
  width: 1000px;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 40px 0 20px;
  }

  .footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
    height: 66px;
    opacity: 1;
    background: #fff;
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, .04), 0 2px 4px 0 rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    z-index: 99;
  }

}

.el-dialog {
  border-radius: 20px;
}
</style>
